// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
var PropertyWizardRelayDescriptionMessage_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionMessage_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayDescriptionMessage_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionMessage_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Description__Message(props) {
  var message = props.message;
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var draft = use(props.draft);
  var match$1 = React.useState(function () {
        return draft.message;
      });
  var tmp;
  tmp = typeof mode !== "object" || mode.TAG !== "Rebroadcast" ? "optional" : undefined;
  var tmp$1;
  tmp$1 = typeof mode !== "object" || mode.TAG !== "Rebroadcast" ? "For example: Professional photos coming Thursday, in process of going through \"make-ready\" but will show now by appointment, interior not ready for showing until estate removes items from property." : "For example: 1267 North is back on the market, and priced well for the perfect renovation opportunity. Available this weekend by appointment. Call Mike to schedule an appointment 415-853-3098.";
  var tmp$2;
  tmp$2 = typeof mode !== "object" || mode.TAG !== "Rebroadcast" ? "Use this if there's anything else you'd like your TAN colleagues to know. It is not shared with clients." : "Tell your TAN colleagues why you're rebroadcasting this property. This message is not shared with clients.";
  return JsxRuntime.jsxs(CssGrid.Cell, {
              width: 12,
              children: [
                JsxRuntime.jsx(PropertyWizardFormRelay__Elements.RichTextEditorField.make, {
                      onFocus: (function (param) {
                          message.onFocus();
                        }),
                      labelText: "Message for TAN colleagues",
                      optionalText: tmp,
                      placeholderText: tmp$1,
                      helpText: tmp$2,
                      onChange: (function (param) {
                          message.onChange(PropertyWizardRelayUtils.FormUtils.noneIfEmpty(param.content));
                        }),
                      onBlur: (function (param) {
                          message.onBlur();
                        }),
                      initialContent: match$1[0],
                      status: message.status
                    }),
                JsxRuntime.jsx(Form__Components.FieldError.make, {
                      valid: message.valid
                    })
              ]
            });
}

var Components;

var TextInputField;

var Cell;

var Validators;

var FormUtils;

var Elements;

var make = PropertyWizardRelay__Description__Message;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Elements = Elements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react Not a pure module */
